import { FreshersScreen } from 'app/features/freshers/screens'
import { freshersPageQuery } from 'app/features/freshers/screens/freshers-screen/queries'
import { initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page(props: any) {
  return <FreshersScreen {...props} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req, query }) => {
  const user = req?.session?.user
  const draft = !!query?.preview

  const client = initializeApollo({
    token: user?.token,
    previewToken: query?.token as string,
  })

  await client.query({
    query: freshersPageQuery.query,
    variables: {
      draft,
    },
  })

  return {
    props: {
      user: user || null,
      preview: draft,
    },
  }
})
